





























import { GeekSkill } from '@/models/geek-profile';
import { getPercentValue } from '@/utils';
import Vue from 'vue';

export default Vue.extend({
  name: 'SkillProgress',
  props: {
    skillScore: Object as () => GeekSkill,
  },
  computed: {
    currentLevelProgressPercents(): number {
      return getPercentValue(this.skillScore.gxpCollectedForNextLevel, this.skillScore.gxpStepForNextLevel);
    },
    progressBarTooltipText(): string {
      return this.$t(
        'geek-profile.tooltips.skill-progress',
        {
          currentPoints: this.skillScore.gxpCollectedForNextLevel,
          nextLevelPoints: this.skillScore.gxpStepForNextLevel,
          nextLevel: this.skillScore.currentLevel + 1,
          skill: this.$t(`skill.${this.skillScore.skill}.name`),
        },
      ) as string;
    },
  },
});
